mutation EntityTagTravelAuthorizationCreate(
  $input: EntityTagTravelAuthorizationCreateInput!
) {
  entityTagTravelAuthorizationCreate(input: $input) {
    entityTags {
      id
      tagId
      entityId
      appId
    }
  }
}
